import React from 'react'
import '../../../assets/css/AboutSection.css'
const AboutSection = () => {
    return (
        <div>
            <section class="about-section"id="about">
                <h2 class="about-title">About</h2>
                <p class="about-text">
                    Raised in Chennai, Uthara Menon is a visionary in fashion, renowned for her signature styles that have graced South Indian cinema’s biggest icons. Her designs blend elegance and versatility, whether it's everyday wear or festive attire. Uthara’s belief in freedom led to the creation of B'Less, a bold braless line, while her compassion birthed BLOOM, offering comfort to mastectomy patients.
                </p>
                <p class="about-text">
                    Welcome to Uthara Menon’s world, where fashion embraces freedom and soul.
                </p>
            </section>

            <section class="innovation-banner">
                <h2 class="banner-title">Introducing Uthara Menon's Trio of Innovation</h2>
                <p class="banner-subtitle">Style, Freedom, and Empowerment Redefined</p>
            </section>


        </div>
    )
}

export default AboutSection